import Swiper from 'swiper';
import { A11y, Autoplay, FreeMode, Keyboard, Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/a11y';
import 'swiper/css/autoplay';
import 'swiper/css/free-mode';
import 'swiper/css/keyboard';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { getApplicationInstance } from '../init/core/Application';
import type { CSSSelector, SwiperOptions } from 'swiper/types';

export default function createSwiperInstance(
    container: CSSSelector | HTMLElement,
    options?: SwiperOptions,
    name?: string
) {
    const instance = new Swiper(container, {
        modules: [A11y, Autoplay, FreeMode, Keyboard, Navigation, Pagination],
        ...options,
    });

    const applicationInstance = getApplicationInstance();
    applicationInstance?.addSwiperInstance(instance, name);

    return instance;
}
